module.exports = __webpack_public_path__ + "static/media/ns-logo-white.7efd3e97.png";